import App from './App.vue';
import { createApp } from 'vue';
import { store } from './store';
import { installVuetify } from './plugins/vuetify';
import ConstantsPlugin from './plugins/constants';
import TranslationsPlugin from './plugins/translations';
import VueCookies from 'vue-cookies'
import "./assets/styles/scss/index.scss";

const app = createApp(App);

app.use(VueCookies)
app.use(store);
app.use(ConstantsPlugin);

const translationsPlugin = new TranslationsPlugin();
await translationsPlugin.init(app);

installVuetify(app);

app.mount('#app');

window.addEventListener("message", function(event) {

    if (!event.data || !event.data.name) {
        return;
    }

    switch (event.data.name) {
        case 'scrollToBottom':
            scrollToBottom();
            break;
        case 'resizeWidget':
            resizeWidget(event.data);
            break;
        case 'endLiveChat':
            break;
        case 'lhcWidgetEvent':
            handleLiveChatWidgetEvent(event.data);
            break;
        default:
            break;
    }

    return;
});

function scrollToBottom() {
    window.scrollTo(0, document.body.scrollHeight);
}

function resizeWidget(eventData) {
    const app = document.getElementById('app');

    if (eventData.height <= 600 && eventData.width <= 450) {
        app.classList.add('small-viewport');
    } else {
        app.classList.remove('small-viewport');
    }
}

function handleLiveChatWidgetEvent(lhcEvent) {
    const eventName = lhcEvent.eventName;
    switch (eventName) {
        case 'chatWidgetOpen':
            handleLiveChatWidgetOpened();
            break;
        case 'chatWidgetClosed':
            handleLiveChatWidgetClosed();
            break;
        case 'lhcError':
            handleDisplayLhcError(lhcEvent.eventData);
            break;
        default:
            break;
    }
}

function handleLiveChatWidgetOpened() {
    sendParentEvent('livechatOpened', true);
}

function handleLiveChatWidgetClosed() {
    const appElement = document.querySelector('#app');

    if (appElement && appElement.classList.contains('embedded-livechat-widget')) {
        appElement.classList.remove('embedded-livechat-widget');
    }

    sendParentEvent('livechatClosed', true);
}

function handleDisplayLhcError(eventData) {
    console.error("LHC ERRORS event data: ", eventData);
    // TODO: Better displaying of lhc errors
    window.alert("There was an issue submitting your livechat. Please try again later.")
}

// Will send a message to the proteus widget wrapper, if we are currently embedded on a page
function sendParentEvent(eventName, eventData) {
    
    let parent = null;
    if (window.opener && window.opener.closed === false) {
        parent = window.opener;
    } else if (window.parent && window.parent.closed === false) {
        parent = window.parent;
    }

    if (!parent) return;

    try {
        parent.postMessage({ 
            'name': 'proteusWidgetEvent', 
            'eventName': eventName, 
            'eventData': eventData 
        }, '*');
    } catch (error) {
        console.error(error);
    }
}